import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-431294ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Import Contract from TX", -1))
const _hoisted_2 = { class: "form-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Destination Folder", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "/" }, "/", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Network", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "TX ID", -1))
const _hoisted_11 = { class: "text-right form-radio" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "modal-footer text-right" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Load files into Workspace", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "modal-button",
  disabled: ""
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading ...", -1))
const _hoisted_22 = [
  _hoisted_21
]

import { ref, watchEffect, onMounted } from 'vue';
import { ArweaveWrapper, arweaveNetworks, defaultNetwork } from '@/core/ArweaveWrapper';
import { ArDBWrapper } from '@/core/ArDBWrapper';
import { WarpContracts } from '@/core/WarpContracts';
import { WasmSrc } from 'warp-contracts';
import { createToast } from 'mosha-vue-toastify';
import DefaultIcon from '@/components/atomic/DefaultIcon';
import DefaultModal from '@/components/atomic/DefaultModal.vue';
import { EvaluationOptions  } from 'warp-contracts'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadContractFromTxDialog',
  props: {
  show: Boolean,
  workspace: Object,
  tx: String,
  txField: String,
  networkParam: String
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;



const showTracker = ref(false);

const txtLoadTXTxField = ref('');
const selLoadTXLocation = ref('');
const txtLoadTXGetLastState = ref(false);
const txtAllowUnsafeClient = ref(false);
const txtAllowBigInt = ref(false);
const txtInternalWrites = ref(false);
const loadingContractTX = ref(false);
const defaultSelNetwork = props.networkParam ? props.networkParam : defaultNetwork;
const selNetwork = ref(defaultSelNetwork);

const closeModal = () => {
  showTracker.value = false;
  emit('close');
};

const initModalFields = () => {
  // Init fields
  if (!props.txField) {
    txtLoadTXTxField.value = '';
    selLoadTXLocation.value = '/';
  }
  txtLoadTXGetLastState.value = false;
  txtAllowUnsafeClient.value = false;
  txtAllowBigInt.value = false;
  txtInternalWrites.value = false;
  selNetwork.value = defaultSelNetwork;
};

watchEffect(() => {
  if (props.show && !showTracker.value) {
    showTracker.value = true;
    initModalFields();
  }
});

onMounted(() => {
  if (props.txField) {
    txtLoadTXTxField.value = props.txField;
    selLoadTXLocation.value = `/${props.txField}`;
  }
});

const loadFromTXModal = async (tx: string, path: string) => {
  const allowUnsafeClient = txtAllowUnsafeClient.value;
  const allowBigInt = txtAllowBigInt.value;
  const internalWrites = txtInternalWrites.value;
  const options: Partial<EvaluationOptions> = {
    allowUnsafeClient,
    allowBigInt,
    internalWrites
  };
  
  loadingContractTX.value = true;
  try {
    await loadEditorFromTX(tx, path);

    if (txtLoadTXGetLastState.value) {
      await loadLatestContractStateFromTX(tx, path, options);
    }
  } catch (err) {
    createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
  loadingContractTX.value = false;
  closeModal();
};


const loadEditorFromTX = async (tx: string, path: string) => {
  const arweaveWrapper = new ArweaveWrapper(selNetwork.value);
  const arweave = arweaveWrapper.arweave;
  const ardbWrapper = new ArDBWrapper(arweave);
  const ardb = ardbWrapper.ardb;
  let res = undefined;
  const onlyInParent= false;
  const inputEvent = new Event('empty-event');

  try {
    res = await ardb.search('transaction').id(
      tx
    ).findOne();
  } catch (err) {
    console.log('loadEditorFromTx', err)
  }


  if (res) {
    const tags = {};
    // Get contract if possible
    res.tags.forEach(async tag => {
      const key = tag.name;
      const value = tag.value;
      tags[key] = value;
    });
    const datatype = res.data.type;
    let data = '';
    let filename = `${tx}`;
    if (datatype === 'application/javascript') {
      filename = `${tx}.js`;

      data = await arweaveWrapper.getTXData(tx);
      createToast(`JS file found!`,
        {
          type: 'success',
          showIcon: true,
          position: 'bottom-right',
        });
    } else if (datatype === 'application/json') {
      filename = `${tx}.json`;
      data = await arweaveWrapper.getTXData(tx);
      const replacer = undefined;
      const space = 4;
      if (data) {
        data = JSON.stringify(JSON.parse(data), replacer, space);
      }
      createToast(`JSON file found!`,
        {
          type: 'success',
          showIcon: true,
          position: 'bottom-right',
        });
    } else if (datatype === 'application/wasm') {
      data = await arweaveWrapper.getTXData(tx, false);
      const buffer = Buffer.from(data);
      //filename = `${tx}.wasm`;
      const wasmSrc = new WasmSrc(buffer);
      data = await wasmSrc.sourceCode();

      // workspace.addEditor(inputEvent, onlyInParent, buffer.toString(), filename, path);
      createToast(`WASM source found!`,
      {
        type: 'success',
        showIcon: true,
        position: 'bottom-right',
      });

      // Load all source files
      for (const tmpFName of data.keys()) {
        const finalNameArr = tmpFName.split('/');
        let finalName = '';
        let finalPath = '';
        if (finalNameArr.length) {
          const finalIndex = finalNameArr.length - 1;
          finalName = finalNameArr[finalIndex];

          // Create new directories
          if (finalIndex - 1 >= 0) {
            finalPath = finalNameArr.slice(0, finalIndex).join('/');
            createDirectoryStructure(path, finalPath);
          }
        }

        const fileId = props.workspace.findFileIdByName(path, tmpFName);
        if (fileId < 0) {
          props.workspace.addEditor(
            inputEvent, 
            onlyInParent, 
            data.get(tmpFName), 
            finalName, 
            `${path}/${finalPath}`);
        } else {
          console.log(`${tmpFName} already in workspace!`);
          props.workspace.selectEditor(fileId, new Event('selectEditor'));
        }
      }

      
      // force End wasm
      return;
    } else {
      data = Object.prototype.hasOwnProperty.call(tags, 'Init-State') ?
      tags['Init-State'] : '';
      if (data) {
        filename = `${tx}.json`;
        const replacer = undefined;
        const space = 4;
        data = JSON.stringify(JSON.parse(data), replacer, space);
        createToast(`NFT Atomic Asset found! Loading state ...`,
        {
          type: 'success',
          showIcon: true,
          position: 'bottom-right',
        });
      } else {
        throw Error('Invalid contract source!');
      }
    }

    props.workspace.addEditor(inputEvent, onlyInParent, data, filename, path);
    // Search if it has a contract src available
    const contractSrc = Object.prototype.hasOwnProperty.call(tags, 'Contract-Src') ?
      tags['Contract-Src'] : '';

    if (contractSrc) {
      await loadEditorFromTX(tags['Contract-Src'], path, props.workspace);
    }

  } // If tx not found
  else {
    try {
      const gatewayUrl = arweaveWrapper.secondaryRedstoneGW;
      createToast(`Fetching contract from secondary gw ...`,
        {
          type: 'warning',
          showIcon: true,
          position: 'bottom-right',
      });
      const tmp_res = await fetch(`${gatewayUrl}/gateway/contracts/${tx}`);
      if (tmp_res.ok) {
        const tmp_data = JSON.parse(await tmp_res.text());
        let srcData = tmp_data.src;
        let initStateData = '';

        if (tmp_data.initState) {
          const replacer = undefined;
          const space = 4;
          initStateData = JSON.stringify(tmp_data.initState, replacer, space);
        }

        // Check if it is WASM
        let fileNameJs = `${tx}.js`;
        let WASMbuffer = null;
        if (!srcData && tmp_data.srcBinary) {
          fileNameJs = `${tx}.wasm`;
          srcData = undefined;
          WASMbuffer = Buffer.from(tmp_data.srcBinary);
        }
        const fileIdJs = props.workspace.findFileIdByName(path, fileNameJs);
        if (fileIdJs < 0 && srcData) {
          props.workspace.addEditor(inputEvent, onlyInParent, srcData, fileNameJs, path);
        } else if (fileIdJs >= 0) {
          console.log(`${tx}.js already in workspace!`);
          props.workspace.selectEditor(fileIdJs, new Event('selectEditor'));
        }

        const fileIdJson = props.workspace.findFileIdByName(path, `${tx}.json`);
        if (fileIdJson < 0 && initStateData) {
          props.workspace.addEditor(inputEvent, onlyInParent, initStateData, `${tx}.json`, path);
        } else if (fileIdJson >= 0) {
          console.log(`${tx}.json already in workspace!`);
          props.workspace.selectEditor(fileIdJson, new Event('selectEditor'));
        }

        // Load WASM
        if (!WASMbuffer) {
          // End function
          return;
        }

        const wasmSrc = new WasmSrc(WASMbuffer);
        const sourceCodeObj = await wasmSrc.sourceCode();

        createToast(`WASM source found!`,
        {
          type: 'success',
          showIcon: true,
          position: 'bottom-right',
        });

        // Load all source files
        for (const tmpFName of sourceCodeObj.keys()) {
          const finalNameArr = tmpFName.split('/');
          let finalName = '';
          let finalPath = '';
          if (finalNameArr.length) {
            const finalIndex = finalNameArr.length - 1;
            finalName = finalNameArr[finalIndex];

            // Create new directories
            if (finalIndex - 1 >= 0) {
              finalPath = finalNameArr.slice(0, finalIndex).join('/');
              createDirectoryStructure(path, finalPath);
            }
          }

          const fileId = props.workspace.findFileIdByName(path, tmpFName);
          if (fileId < 0) {
            props.workspace.addEditor(
              inputEvent, 
              onlyInParent, 
              sourceCodeObj.get(tmpFName), 
              finalName, 
              `${path}/${finalPath}`);
          } else {
            console.log(`${tmpFName} already in workspace!`);
            props.workspace.selectEditor(fileId, new Event('selectEditor'));
          }
        }
        
      }
    } catch (err) {
      console.log('loadEditorFromTx2', err)
    }
  }
};


const loadLatestContractStateFromTX = async (
  tx: string, path: string, options: Partial<EvaluationOptions>) => {
  const arweaveWrapper = new ArweaveWrapper(selNetwork.value);
  const arweave = arweaveWrapper.arweave;
  const warpContracts = new WarpContracts(arweave);
  const { cachedValue } = await warpContracts.readState(
    tx, options
  );
  const state = cachedValue &&
    Object.prototype.hasOwnProperty.call(cachedValue, 'state') ?
    cachedValue.state : {};
    
  const onlyInParent= false;
  const inputEvent = new Event('empty-event');
  const filename = `${tx}-latest.json`;
  const replacer = undefined;
  const space = 4;
  props.workspace.addEditor(
    inputEvent,
    onlyInParent,
    JSON.stringify(state, replacer, space),
    filename, path);
  createToast(`Contract latest state loaded!`,
    {
      type: 'success',
      showIcon: true,
      position: 'bottom-right',
    });
};

const createDirectoryStructure = (root: string, path: string) => {
  const elements = path.split('/');
  let tmpPath = `${root}`;
  for (const e of elements) {
    try {
      props.workspace.addFolder(`${tmpPath}`, e, true);
      tmpPath += `/${e}`;
    } catch (err) {
      console.log('dirStructure:', err);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createBlock(DefaultModal, { key: 0 }, {
        header: _withCtx(() => [
          _createElementVNode("h3", null, [
            _createVNode(_unref(DefaultIcon), {
              class: "title-icon",
              icon: "codicon-mirror"
            }),
            _hoisted_1
          ])
        ]),
        body: _withCtx(() => [
          (!loadingContractTX.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selLoadTXLocation).value = $event))
                  }, [
                    _hoisted_4,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreePaths(), (path) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
                        path
                          ? (_openBlock(), _createElementBlock("option", {
                              key: 0,
                              value: path
                            }, _toDisplayString(path), 9, _hoisted_5))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 512), [
                    [
                      _vModelSelect,
                      selLoadTXLocation.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selNetwork).value = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(arweaveNetworks), (nItem, nIndex) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: nIndex,
                        value: nIndex
                      }, _toDisplayString(nItem.host) + " (" + _toDisplayString(nIndex) + ")", 9, _hoisted_8))
                    }), 128))
                  ], 512), [
                    [
                      _vModelSelect,
                      selNetwork.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((txtLoadTXTxField).value = $event)),
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (txtLoadTXTxField.value != '' ? loadFromTXModal(txtLoadTXTxField.value, selLoadTXLocation.value) : false), ["enter"])),
                    type: "text"
                  }, null, 544), [
                    [
                      _vModelText,
                      txtLoadTXTxField.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (__props.tx)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "link",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (txtLoadTXTxField.value = __props.tx))
                      }, "Use TX address from URL"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((txtLoadTXGetLastState).value = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        txtLoadTXGetLastState.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createTextVNode(" Get last state (it can take longer to load) ")
                  ]),
                  _createElementVNode("label", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((txtAllowUnsafeClient).value = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        txtAllowUnsafeClient.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createTextVNode(" allowUnsafeClient (Insecure) ")
                  ]),
                  _createElementVNode("label", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((txtAllowBigInt).value = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        txtAllowBigInt.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createTextVNode(" allowBigInt ")
                  ]),
                  _createElementVNode("label", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((txtInternalWrites).value = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        txtInternalWrites.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createTextVNode(" internalWrites ")
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (loadingContractTX.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Loading ... Please hold on! ")
              ], 64))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            (!loadingContractTX.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["modal-button", { 'modal-button-primary': txtLoadTXTxField.value }]),
                  disabled: !txtLoadTXTxField.value,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (loadFromTXModal(txtLoadTXTxField.value, selLoadTXLocation.value)))
                }, _hoisted_19, 10, _hoisted_17))
              : _createCommentVNode("", true),
            (loadingContractTX.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_20, _hoisted_22))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "modal-button",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (closeModal()))
            }, " Close ")
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})